import type { Setup } from "features/setups/types";
import { BaseSetupValue, type CsvValue, type ISetupValue } from "../../types";

export class CsvSetupValue extends BaseSetupValue<CsvValue> implements ISetupValue<CsvValue> {
    public deserialize(setupValue: Setup<string>['setupValue']): CsvValue {
        return setupValue.split(',')
            .map(item => item.trim())
            .filter(Boolean);
    }

    public serialize() {
        return this.value.join(',');
    }
}

export default CsvSetupValue;
